import React, { useEffect } from 'react';
import { Provider } from '@supabase/supabase-js';
import clsx from 'clsx';
import { ReactComponent as IconApple } from 'images/social/apple.svg';
import { ReactComponent as IconGoogle } from 'images/social/google.svg';
import useLoginWithProvider from 'sdk/hooks/useLoginWithProvider';
import styles from './SocialLinks.module.scss';
import { useTranslation } from 'react-i18next';

type ProviderItem = {
  id: Provider;
  name: string;
  icon: React.ReactNode;
};

function SocialLinks() {
  const loginMutation = useLoginWithProvider({
    options: {
      redirectTo: `${window.location.origin}/feed`,
      provider: 'google',
    },
  });
  const { t } = useTranslation() as any;
  useEffect(() => {
    if (loginMutation.isError) console.log('error');
  }, [loginMutation.isError]);

  const providers: ProviderItem[] = [
    { id: 'google', name: 'Google', icon: <IconGoogle /> },
    { id: 'apple', name: 'Apple', icon: <IconApple /> },
  ];

  return (
    <div className={clsx(styles.socialItemsContainer, 'scroll scroll-y')}>
      <div className={styles.socialItems}>
        {providers.map(p => (
          <div
            key={p.id}
            className={styles.socialItem}
            onClick={() =>
              loginMutation.mutate(p.id, {
                onSuccess() {
                  console.log('login');
                },
              })
            }
          >
            <div className={styles.socialItem_icon}>{p.icon}</div>
            {t('continue_with_provider', { provider: p.name })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SocialLinks;
